import styled from 'styled-components';
import ImgModalFirstBulletin from 'assets/images/img-modal-first-bulletin.svg';

export const Container = styled.div`
  .close {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .bg-modal-first-bulletin {
    background: #184f71 bottom center;
    background-image: url('${ImgModalFirstBulletin}');
    background-repeat: no-repeat;
  }
`;
